import cropChecklists from "./cropChecklists";
import groupChecklists from "./groupChecklists";
import selfProducesChecklists from "./selfProducesChecklists";
import organicChecklist_crop from "./organicChecklist_crop";
import organicChecklist_processing from "./organicChecklist_processing";

const inspectionChecklistService = [{
    matcher: "inspectionChecklist/cropChecklist",
    reply: config => {
        return [200, cropChecklists]
    }
},{
    matcher: "inspectionChecklist/groupChecklist",
    reply: config => {
        return [200, groupChecklists]
    }
},{
    matcher: "inspectionChecklist/selfProducesChecklist",
    reply: config => {
        return [200, selfProducesChecklists]
    }
},{
    matcher: "inspectionChecklist/organicChecklistCrop",
    reply: config => {
        return [200, organicChecklist_crop]
    }
},{
    matcher: "inspectionChecklist/organicChecklistProcessing",
    reply: config => {
        return [200, organicChecklist_processing]
    }
}]

export default inspectionChecklistService;